import React, { Fragment } from 'react';

import { nowUtil, subtractFromDateWithFormat } from '@utils/dates/date.utils';
import { YYYY } from '@utils/dates/dateFormats.utils';

import RenderConsumerSignUpNotEnabled from './fragments/RenderConsumerSignupNotEnabled';
import RenderConsumerSignUpEnabled from './fragments/RenderConsumerSignUpEnabled';
import { IHomeProps } from './utils';
import { ConditionalRendering } from '@common-components/conditional-rendering';

const Home = (props: IHomeProps) => {
    const {
        environment: { exchangeName, isState, isMNFullStack, consumerSignupEnabled, landingPageAnonymousTileShow },
        path,
    } = props;
    const currentYear = nowUtil(YYYY);
    const previousYear = subtractFromDateWithFormat(1, 'year', YYYY);

    return (
        <Fragment>
            <ConditionalRendering isTrue={consumerSignupEnabled}>
                <RenderConsumerSignUpEnabled
                    {...{ exchangeName, isState, isMNFullStack, path, currentYear, landingPageAnonymousTileShow }}
                />
            </ConditionalRendering>
            <ConditionalRendering isTrue={!consumerSignupEnabled}>
                <RenderConsumerSignUpNotEnabled {...{ currentYear, previousYear, exchangeName }} />
            </ConditionalRendering>
        </Fragment>
    );
};

export default Home;
